export default "__VITE_ASSET__da84f923__"